import { GradientPath } from 'gradient-path';
import { animate } from '../node_modules/framer-motion/dist/es/animation/animate.mjs.js';

var GAP = 0.01;
var GAP_MUL = 10;
var getGradientColor = function getGradientColor(_a) {
  var v = _a.v,
    playReverse = _a.playReverse,
    mainColor = _a.mainColor,
    pointColor = _a.pointColor;
  if (v > 1 - GAP) {
    return [{
      color: mainColor,
      pos: 0
    }, {
      color: mainColor,
      pos: 1
    }];
  } else if (v >= GAP * GAP_MUL) {
    return playReverse ? [{
      color: 'white',
      pos: 1 - v
    }, {
      color: pointColor,
      pos: 1 - v + GAP
    }, {
      color: mainColor,
      pos: 1 - v + GAP * GAP_MUL
    }] : [{
      color: mainColor,
      pos: v - GAP * GAP_MUL
    }, {
      color: pointColor,
      pos: v
    }, {
      color: 'white',
      pos: v + GAP
    }];
  } else if (v >= GAP * GAP_MUL / 2) {
    return playReverse ? [{
      color: 'white',
      pos: 1 - v
    }, {
      color: pointColor,
      pos: 1 - v + GAP
    }, {
      color: mainColor,
      pos: 1 - v + GAP * GAP_MUL / 2
    }] : [{
      color: mainColor,
      pos: v - GAP * GAP_MUL / 2
    }, {
      color: pointColor,
      pos: v
    }, {
      color: 'white',
      pos: v + GAP
    }];
  } else if (v >= GAP) {
    return playReverse ? [{
      color: 'white',
      pos: 1 - v
    }, {
      color: pointColor,
      pos: 1 - v + GAP
    }] : [{
      color: pointColor,
      pos: v
    }, {
      color: 'white',
      pos: v + GAP
    }, {
      color: 'white',
      pos: 1
    }];
  }
  return [{
    color: 'white',
    pos: 0
  }, {
    color: 'white',
    pos: v
  }];
};
var reset = function reset() {
  var elements = document.querySelectorAll('.element-path');
  elements.forEach(function (element) {
    return element.remove();
  });
};
var createGradientPath = function createGradientPath(pathRef) {
  if (pathRef === null || pathRef === void 0 ? void 0 : pathRef.current) {
    return new GradientPath({
      path: pathRef === null || pathRef === void 0 ? void 0 : pathRef.current,
      segments: 80,
      samples: 10,
      precision: 2 // Optional 경로의 각 점에 대해 유지할 소수 자릿수
    });
  }
};

var setPathAnimation = function setPathAnimation(_a) {
  var gp = _a.gp,
    duration = _a.duration,
    lineWidth = _a.lineWidth,
    playReverse = _a.playReverse,
    mainColor = _a.mainColor,
    pointColor = _a.pointColor;
  return animate(0, 1, {
    duration: duration,
    onPlay: function onPlay() {
      return reset();
    },
    onRepeat: function onRepeat() {
      return reset();
    },
    onUpdate: function onUpdate(v) {
      gp.render({
        type: 'path',
        fill: getGradientColor({
          v: v,
          playReverse: playReverse,
          mainColor: mainColor,
          pointColor: pointColor
        }),
        width: lineWidth
      });
    }
  });
};

export { createGradientPath, setPathAnimation };
